module.exports = __webpack_public_path__ + "static/media/icon-speech-bubble.19127704.svg";